import exp from "constants";

const Dashboard = () => {
    return (
        <div className="App-header">
            <div className="container-sm container-md container-lg container-xl container-xxl">
                <p>This page is under development.</p>
            </div>
        </div>

    )
}


export default Dashboard
